import React, { FunctionComponent, useEffect } from 'react';
import * as platforms from '@stores/platforms';
import * as featuring from '@stores/featuring';
import { useStore } from 'effector-react';
import modals, { IModalsState } from '@stores/modals';
import { FeaturingEditModal, FeaturingList } from '@pages/FeaturingPage';
import * as postSelector from '@stores/postSelector';
import useListWithQuery from '@hooks/useListWithQuery';

import css from './FeaturingRoute.module.less';
import PromotionSelector from '@components/PromotionSelector';

const FeaturingRoute: FunctionComponent<unknown> = () => {
  useListWithQuery(featuring.getList, featuring.reset);
  useEffect(() => {
    platforms.getList();
    return () => {
      platforms.reset();
    };
  }, []);

  const {
    visibleState: { featuring: visible },
    data,
  } = useStore<IModalsState<any>>(modals);
  useEffect(() => {
    postSelector.reset();
  }, [visible]);

  return (
    <div className={css.root}>
      <div className={css.selector}>
        <PromotionSelector />
      </div>
      <div className={css.list}>
        <FeaturingList />
      </div>
      {visible ? <FeaturingEditModal data={data} /> : null}
    </div>
  );
};

export default FeaturingRoute;
